import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "css-input css-checkbox css-checkbox-rounded css-checkbox-primary" }
const _hoisted_3 = ["checked", "aria-labelledby"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border pad-10", { 'border-active': _ctx.selected, 'hover-pointer': !_ctx.selected }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" Really funky markup from OneUI "),
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("input", {
          checked: _ctx.selected,
          type: "checkbox",
          class: "display-none",
          "aria-labelledby": _ctx.labelIDs
        }, null, 8 /* PROPS */, _hoisted_3),
        _hoisted_4
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}